const translations = {
    lastNameFieldLabel: 'LAST NAME PLEASE'
};

export default translations;
